import { Link, useNavigate } from "react-router-dom";
import { LogOut, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { LOGO_URL } from "@/lib/brand";

export const Header = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-50 border-b border-slate-200/80 bg-white/90 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-8">
        <Link to="/" className="flex items-center gap-3" data-testid="brand-home-link">
          <img src={LOGO_URL} alt="Haba Trans Logistique" className="h-9 w-auto object-contain" />
          <span className="hidden font-mono text-[10px] uppercase tracking-[0.18em] text-slate-500 sm:block">
            Canada → Côte d'Ivoire
          </span>
        </Link>

        <div className="flex items-center gap-2">
          {user ? (
            <>
              <Button
                variant="ghost"
                className="text-sm font-semibold text-[#1E3A8A] hover:bg-blue-50"
                onClick={() => navigate("/admin")}
                data-testid="header-dashboard-link"
              >
                Tableau de bord
              </Button>
              <Button
                variant="outline"
                className="gap-2 border-slate-300 text-sm"
                onClick={async () => {
                  await logout();
                  navigate("/");
                }}
                data-testid="header-logout-button"
              >
                <LogOut className="h-4 w-4" />
                <span className="hidden sm:inline">Déconnexion</span>
              </Button>
            </>
          ) : (
            <Button
              className="gap-2 rounded-full bg-[#1E3A8A] px-5 text-sm font-semibold text-white hover:bg-[#172d6d]"
              onClick={() => navigate("/admin/login")}
              data-testid="header-admin-login-button"
            >
              <ShieldCheck className="h-4 w-4" />
              Espace admin
            </Button>
          )}
        </div>
      </div>
    </header>
  );
};
